module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'nhfarssu',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
